import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

import Home from './pages/public/Home';
import Login from './pages/public/Login';
import Register from './pages/public/Register';
import Payment from './pages/public/Payment';
import Plans from './pages/public/Plans';
import About from './pages/public/About';
import Contact from './pages/public/Contact';
import ForgotPassword from './pages/public/ForgotPassword';
import AdminLogin from './pages/public/AdminLogin';

import DashLayout from './components/DashLayout';
import DashHome from './pages/dashboard/DashHome';
import CRM from './pages/dashboard/CRM';
import WhatsApp from './pages/dashboard/WhatsApp';
import Campaigns from './pages/dashboard/Campaigns';
import AutoReply from './pages/dashboard/AutoReply';
import Widget from './pages/dashboard/Widget';
import Analytics from './pages/dashboard/Analytics';
import Billing from './pages/dashboard/Billing';
import Tickets from './pages/dashboard/Tickets';
import Notifications from './pages/dashboard/Notifications';
import Profile from './pages/dashboard/Profile';

import AdminLayout from './components/AdminLayout';
import AdminHome from './pages/admin/AdminHome';
import AdminUsers from './pages/admin/AdminUsers';
import AdminPayments from './pages/admin/AdminPayments';
import AdminLeads from './pages/admin/AdminLeads';
import AdminTickets from './pages/admin/AdminTickets';
import AdminAnnouncements from './pages/admin/AdminAnnouncements';
import AdminNotifications from './pages/admin/AdminNotifications';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: 16 }}>
      <div style={{ width: 36, height: 36, border: '3px solid var(--border)', borderTop: '3px solid var(--green)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      <span style={{ color: 'var(--text-muted)', fontSize: 14 }}>Loading...</span>
    </div>
  );
  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('msreach_admin_token');
  return token ? children : <Navigate to="/admin/login" />;
};

const D = (Layout, Page) => <PrivateRoute><Layout><Page /></Layout></PrivateRoute>;
const A = (Page) => <AdminRoute><AdminLayout><Page /></AdminLayout></AdminRoute>;

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { background: '#1a1a1a', color: '#fff', border: '1px solid #222', fontSize: 13, borderRadius: 10 },
            success: { iconTheme: { primary: '#00E74C', secondary: '#000' } },
            error: { iconTheme: { primary: '#ff4444', secondary: '#fff' } },
            duration: 3000,
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/login" element={<AdminLogin />} />

          <Route path="/dashboard" element={D(DashLayout, DashHome)} />
          <Route path="/dashboard/crm" element={D(DashLayout, CRM)} />
          <Route path="/dashboard/whatsapp" element={D(DashLayout, WhatsApp)} />
          <Route path="/dashboard/campaigns" element={D(DashLayout, Campaigns)} />
          <Route path="/dashboard/autoreply" element={D(DashLayout, AutoReply)} />
          <Route path="/dashboard/widget" element={D(DashLayout, Widget)} />
          <Route path="/dashboard/analytics" element={D(DashLayout, Analytics)} />
          <Route path="/dashboard/billing" element={D(DashLayout, Billing)} />
          <Route path="/dashboard/tickets" element={D(DashLayout, Tickets)} />
          <Route path="/dashboard/notifications" element={D(DashLayout, Notifications)} />
          <Route path="/dashboard/profile" element={D(DashLayout, Profile)} />

          <Route path="/admin" element={A(AdminHome)} />
          <Route path="/admin/users" element={A(AdminUsers)} />
          <Route path="/admin/payments" element={A(AdminPayments)} />
          <Route path="/admin/leads" element={A(AdminLeads)} />
          <Route path="/admin/tickets" element={A(AdminTickets)} />
          <Route path="/admin/announcements" element={A(AdminAnnouncements)} />
          <Route path="/admin/notifications" element={A(AdminNotifications)} />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
